import { connect } from 'react-redux';
import { allChannelFeedSelector } from '@/selectors';
import AllChannelFeed from '@/components/Conversation/AllChannelFeed/AllChannelFeed';

const mapStateToProps = allChannelFeedSelector;

export default connect(mapStateToProps)(AllChannelFeed);
